<template>
    <md-app>
      <md-app-toolbar class="md-primary">
        <span class="md-title">Student Bank</span>
      </md-app-toolbar>

      <md-app-drawer id="drawer" :md-active.sync="sidebarVisible" md-permanent="clipped">
      <md-list>
        <md-list-item md-expand >
          <md-icon>account_circle</md-icon>
          <span class="md-list-item-text">{{user ? user.displayName : 'None'}}</span>
          <md-list slot="md-expand">
            <md-list-item v-if="user" @click="logout">
              <md-icon>lock</md-icon>
              <span class="md-list-item-text">Logout</span>
            </md-list-item>
            <md-list-item v-else @click="login">
              <md-icon>lock_open</md-icon>
              <span class="md-list-item-text">Login</span>
            </md-list-item>
          </md-list>
        </md-list-item>
        <template v-if="user && !denied">
          <md-list-item to="/">
            <md-icon>account_balance</md-icon>
            <span class="md-list-item-text">Home</span>
          </md-list-item>
          <md-list-item to="/accounts">
          <md-icon>account_circle</md-icon>
            <span class="md-list-item-text">Account List</span>
          </md-list-item>
          <md-list-item to="/reporting">
            <md-icon>show_chart</md-icon>
            <span class="md-list-item-text">Reporting</span>
          </md-list-item>
          <md-list-item to="/archived-accounts">
          <md-icon>archived</md-icon>
            <span class="md-list-item-text">Archived Accounts</span>
          </md-list-item>
        </template>
      </md-list>
      </md-app-drawer>

      <md-app-content>
      <router-view/>
      
      </md-app-content>
    </md-app>
</template>

<script>
import * as firebase from "firebase/app";
import { mapGetters } from 'vuex';
import { provider} from "@/db";
  export default {
    name: 'App',
    data: () => ({
      showDialog: false,
      name: null,
      selectedIndex: null,
      sidebarVisible: false
    }),
    computed: {
      ...mapGetters(['user', 'denied'])
    },
    watch: {
      denied(newD) {
        if(newD){
          this.$router.replace('/access-denied');
        }
      }
    },
    methods:{
      toggleSidebar(){
        this.sidebarVisible = !this.sidebarVisible
      },
      login() {
        firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) => {
            this.$store.dispatch('login', result.user).then(() => {
              this.$router.replace("/");
            });
          });
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.commit("setUser", null);
          this.$router.replace("/login");
        });
    }
    },
    beforeCreate() {
    firebase.auth().onAuthStateChanged((user) => {
      this.$store.dispatch("login", user || null);
      if (user && this.$route.path === "/login") {
        this.$router.replace("/");
      } else if (!user && this.$route.path !== "/login") {
        this.$router.replace("/login");
      }
    });
  }
  }
</script>
<style lang="scss">
 @import "./assets/theme.scss";
.md-app {
  height: 100vh;
  width: 100vw;
}


#drawer{
  width:300px
}
.md-menu-content{
  z-index: 11 !important;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.text-center{
  text-align: center
}
</style>
